import { useProperty } from './useProperty';
import { isFile } from 'customer-data-objects/property/PropertyIdentifier';
export const useHideFloatingEditIcon = () => {
  const property = useProperty();
  return isFile(property);
};